var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"flex bg-white type-scale-n3 font-medium h-10 items-center w-full flex-shrink-0 select-none sticky top-0 shadow z-10"},_vm._l((_vm.headers),function(header,$i){return _c('div',{key:$i,staticClass:"px-4",style:({ width: _vm.headerWidth(header) })},[_vm._v("\n    "+_vm._s(header.label || header)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }